type Props = {
  direction: 'left' | 'right';
  isPc: boolean;
  peek: number;
  onClick: () => void;
};

export function SaleListBannerArrow({ direction, isPc, peek, onClick }: Props) {
  const isLeft = direction === 'left';
  return (
    <button
      onClick={onClick}
      style={{
        position: 'absolute',
        top: '50%',
        ...(isLeft
          ? { left: isPc ? '3%' : peek / 2.5, transform: 'translate(-50%, -50%)' }
          : { right: isPc ? '3%' : peek / 2.5, transform: 'translate(50%, -50%)' }
        ),
        width: isPc ? 48 : 36,
        height: isPc ? 48 : 36,
        borderRadius: '50%',
        background: 'rgba(0,0,0,0.75)',
        border: 'none',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9,
        padding: 0,
      }}
    >
      <svg width={isPc ? 14 : 11} height={isPc ? 26 : 20} viewBox="0 0 10 18" fill="none">
        {isLeft
          ? <polyline points="9,1 1,9 9,17" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
          : <polyline points="1,1 9,9 1,17" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
        }
      </svg>
    </button>
  );
}
